import { statusBadgeClass } from "../utils";
import Status from "Shared/Common/Status";

const RequisitionStatusBadge = ({ label }: { label: string }) =>
  label ? <Status cusText={label} cusClassName={statusBadgeClass(label)} /> : null;

export default RequisitionStatusBadge;
